export default __webpack_public_path__ + "static/media/CNo.46-0.d60d00b5.jpg";